import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import PublicHome from "@/pages/PublicHome";
import MurPage from "@/pages/public/MurPage";
import IdeesPage from "@/pages/public/IdeesPage";
import AgendaPage from "@/pages/public/AgendaPage";
import PlanPage from "@/pages/public/PlanPage";
import CovoituragePage from "@/pages/public/CovoituragePage";
import CovoiturageTripPage from "@/pages/public/CovoiturageTripPage";
import MyAdvantagesPage from "@/pages/public/MyAdvantagesPage";
import RessourcesPage from "@/pages/public/RessourcesPage";
import NumerosUtilesPage from "@/pages/public/NumerosUtilesPage";
import ConsultationsPage from "@/pages/public/ConsultationsPage";
import HabitantDashboard from "@/pages/HabitantDashboard";
import CommercantDashboard from "@/pages/CommercantDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import FeedbackPage from "@/pages/FeedbackPage";
import SurveysPage from "@/pages/SurveysPage";
import SurveyDetailPage from "@/pages/SurveyDetailPage";
import QuizzesPage from "@/pages/QuizzesPage";
import QuizPlayPage from "@/pages/QuizPlayPage";
import MyVouchersPage from "@/pages/MyVouchersPage";
import MerchantProfilePage from "@/pages/MerchantProfilePage";
import MerchantEventsPage from "@/pages/MerchantEventsPage";
import MerchantStatsPage from "@/pages/MerchantStatsPage";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import Confidentialite from "@/pages/legal/Confidentialite";
import AppShell from "@/components/AppShell";
import AccessibilityWidget from "@/components/AccessibilityWidget";
import AssistantBubble from "@/components/AssistantBubble";
import BadgeUnlockWatcher from "@/components/BadgeUnlockWatcher";
import ScrollToTop from "@/components/ScrollToTop";

function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="text-provence-700 font-display text-2xl animate-pulse">Istres & Moi...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function RoleHome() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <PublicHome />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.role === "commercant") return <Navigate to="/commercant" replace />;
  return <Navigate to="/habitant" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<RoleHome />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<LoginPage />} />
          <Route path="/accueil" element={<PublicHome />} />
          <Route path="/mur" element={<MurPage />} />
          <Route path="/idees" element={<IdeesPage />} />
          <Route path="/agenda" element={<AgendaPage />} />
          <Route path="/plan" element={<PlanPage />} />
          <Route path="/covoiturage" element={<CovoituragePage />} />
          <Route path="/covoiturage/:id" element={<CovoiturageTripPage />} />
          <Route path="/mes-avantages" element={<MyAdvantagesPage />} />
          <Route path="/ressources" element={<RessourcesPage />} />
          <Route path="/numeros-utiles" element={<NumerosUtilesPage />} />
          <Route path="/qui-contacter" element={<NumerosUtilesPage />} />
          <Route path="/consultations" element={<ConsultationsPage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />

          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route path="/habitant" element={<ProtectedRoute roles={["habitant"]}><HabitantDashboard /></ProtectedRoute>} />
            <Route path="/commercant" element={<ProtectedRoute roles={["commercant"]}><CommercantDashboard /></ProtectedRoute>} />
            <Route path="/commercant/fiche" element={<ProtectedRoute roles={["commercant"]}><MerchantProfilePage /></ProtectedRoute>} />
            <Route path="/commercant/evenements" element={<ProtectedRoute roles={["commercant"]}><MerchantEventsPage /></ProtectedRoute>} />
            <Route path="/commercant/stats" element={<ProtectedRoute roles={["commercant"]}><MerchantStatsPage /></ProtectedRoute>} />
            <Route path="/admin/*" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
            <Route path="/remontees" element={<FeedbackPage />} />
            <Route path="/sondages" element={<SurveysPage />} />
            <Route path="/sondages/:id" element={<SurveyDetailPage />} />
            <Route path="/jeux" element={<QuizzesPage />} />
            <Route path="/jeux/:id" element={<QuizPlayPage />} />
            <Route path="/bons" element={<MyVouchersPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <AssistantBubble />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
      <AccessibilityWidget />
      <BadgeUnlockWatcher />
    </AuthProvider>
  );
}

export default App;
